import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'

import { getSelectedPlatform } from '../../helpers/handlePlatformSelection'
import { redirectTo, replaceRouteParams } from '../../helpers/url'

import { partnershipsWasLoadedSelector } from '../../modules/selectors/partnerships'

import { ROUTE_PARAMS, ROUTES } from '../../constants/routes'
import { selectedAdAccountsSelector } from '../../modules/selectors/adAccounts'

export default function useAdAccountsValidation(path) {
  const dispatch = useDispatch()

  const selectedPlatform = getSelectedPlatform()
  const { [ROUTE_PARAMS.adAccount]: pathAdAccountId } = useParams()

  const partnershipsWasLoaded = useSelector(partnershipsWasLoadedSelector)
  const { [selectedPlatform]: selectedAdAccount = {} } = useSelector(selectedAdAccountsSelector)

  const { id: selectedAdAccountId } = selectedAdAccount

  useEffect(() => {
    // validate adAccount and redirect to missing Access page in case of invalid type
    if (pathAdAccountId && partnershipsWasLoaded && selectedPlatform) {
      const isValidAdAccount = pathAdAccountId === selectedAdAccountId

      if (pathAdAccountId && !isValidAdAccount) {
        // when selectedAdAccountId is not in the selectedPartnership adAccounts
        redirectTo(
          replaceRouteParams(ROUTES.adAccountAccessMissing, {
            [ROUTE_PARAMS.platform]: selectedPlatform,
            [ROUTE_PARAMS.adAccount]: selectedAdAccountId
          })
        )
      }
    }
  }, [dispatch, pathAdAccountId, selectedAdAccountId, selectedPlatform, partnershipsWasLoaded, path])
}
